<template>
  <div>
    <logged-in-header />
    <certificate-bar />
    <dashboard />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import dashboard from "../components/dashboard/Dashboard";
import certificateBar from "../components/common/CertificateBar.vue";

export default {
  components: {
    loggedInHeader,
    dashboard,
    certificateBar
  }
};
</script>
